import React from 'react';

const PackagesIntro = () => {
  return (
    <div className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-6 text-[#0760ad]">
            Comprehensive Health Solutions
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            WarmWellness Center's Individual Health Packages offer personalized care that includes 
            thorough check-ups, tailored treatments, and expert medical advice to maintain your 
            optimal wellbeing. Our packages are designed to detect potential health issues early, 
            ensuring timely intervention and better health outcomes.
          </p>
        </div>
        
        <div className="bg-[#f0f9ff] p-6 rounded-xl">
          <p className="text-gray-700">
            Each package can be customized based on your individual health concerns, family history, 
            and lifestyle factors. All packages include consultation with our healthcare professionals 
            to interpret results and provide personalized guidance.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PackagesIntro;